import { useQueryParam } from 'use-query-params'

export type TiktokErrorQueryParams = {
  error?: string
  errorDescription?: string
}

export const useTiktokErrorQueryParams = () => {
  const [error, setError] = useQueryParam<TiktokErrorQueryParams['error']>('error')
  const [errorDescription, setErrorDescription] =
    useQueryParam<TiktokErrorQueryParams['errorDescription']>('error_description')

  return {
    tiktokErrorQueryParams: {
      error,
      errorDescription,
    },
    setTiktokErrorQueryParams: (params: TiktokErrorQueryParams) => {
      setError(params.error)
      setErrorDescription(params.errorDescription)
    },
  }
}
